import PropTypes from 'prop-types';
import React from 'react';
import i18n from 'i18next';
import { Icon, Card, ToastContext } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import GraphHomeEvent from './graphHomeEvent';
import useAppContext from '../../../context/useAppContext';
import { useFetchGraphStatistics } from './statisticsFetcher';
import LoadingCard from '../../../components/loadingCard';
import Styles from '../../../styles/event/dashboard/eventDashboard.module.css';
import { Card as NacreCard } from '../../../components/card';

export default function EvolutionSales({ data = null }) {
    const { t } = useTranslation();
    const toast = React.useContext(ToastContext);
    const [{ organization, event }] = useAppContext();

    const [graphStats, setGraphStats] = React.useState(null);

    useFetchGraphStatistics({
        route: `/ticket/organizations/${organization.id}/events/${event.id}/stats`,
        queryParams: {
            stats: 'attendees_by_event_bimonthly_stats'
        },
        onStats: stats => {
            setGraphStats(stats);
        },
        onError: () => toast.error(t('ticket.eventDashboard.statistics.error_retrieving_stats'))
    });

    const formatedStats = React.useMemo(() => {
        if (!graphStats) {
            return null;
        }
        const _stats = [];
        for (const [key, value] of Object.entries(graphStats[0].value)) {
            _stats.push({
                id: key,
                label: t(`ticket.eventDashboard.chart.${key}`),
                color: key === 'attendees_reservation' ? '#D9E1F3' : '#0032FA',
                data: value
                    ? Object.entries(value)
                          .map(i => {
                              const date = new Date(i[0]);
                              return {
                                  x: Intl.DateTimeFormat(i18n.language).format(new Date(date.getTime() + date.getTimezoneOffset() * 60 * 1000)),
                                  y: i[1]
                              };
                          })
                          .reverse()
                    : null
            });
        }
        return _stats;
    }, [graphStats]);

    const statistics = React.useMemo(() => {
        if (!data) {
            return null;
        }
        const attendeesStats = data.find(groupStats => groupStats.name === 'attendees_stats');
        if (attendeesStats.last_computed) {
            return attendeesStats.value;
        }
        return null;
    }, [data]);

    return (
        <NacreCard
            title={t('ticket.eventDashboard.evolutionSales.title')}
            className={Styles['evolutionSales']}
            headerClassName={Styles['evolutionSales-header']}
            titleClassName={Styles['evolutionSales-title']}
            contentClassName={Styles['evolutionSales-content']}
        >
            <LoadingCard loading={!statistics || !graphStats || graphStats[0]?.last_computed === null}>
                {+statistics?.total_attendees === 0 ? (
                    <Card.EmptyState
                        icon={<Icon name="chart" />}
                        title={t('ticket.eventDashboard.evolutionSales.content.titleNoSell')}
                        subtitle={t('ticket.eventDashboard.evolutionSales.content.subtitleNoSell')}
                    />
                ) : (
                    <div className={Styles['evolutionSales__container']}>
                        <GraphHomeEvent stats={formatedStats} />
                    </div>
                )}
            </LoadingCard>
        </NacreCard>
    );
}

EvolutionSales.propTypes = {
    statistics: PropTypes.object
};
